export default __webpack_public_path__ + "static/sdg-13-77740fbde99c90d71bb752593581930f.png";